import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { BASE_BFF_WEB_URL } from "utilities/Constant";

export interface ValidateOtpRequest {
  otp: string;
  flowId: string;
}

export interface ValidateOtpResponse {
  id: string;
  accessToken: string;
  name: string;
  status: string;
  refreshToken: string;
  version: string;
}

export interface TokensResponse {
  refreshToken: string;
  accessToken: string;
  tokenExpireTime: Date;
}

export interface TokensRequest {
  accessToken: string;
  refreshToken: string;
}

export interface ValidateDeviceAuthRequest {
  deviceAuthId: string;
  otp: string;  
  userId: string;
}

export interface DeviceAuthResponse {
  id: string;
  status: string;
}

export interface UserAuthDto {
  isAuthCompleted: boolean;
  deviceId?: string | null;
  nhDealApplicationId?: string | null;
  userId?: string | null;
}

export interface GetUserAuthInfoParams {
  email: string;
  action?: string | null;
}

export interface DeviceOtpRequest {
  deviceAuthId: string;
  DeviceType: DeviceType;
}

export enum DeviceType {
  Sms = 1,
  Email = 2,
}

export const authenticationApi = createApi({
  reducerPath: "authenticationApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_BFF_WEB_URL, credentials: "include" }),
  endpoints: (build) => ({
    postOtpValidation: build.mutation<ValidateOtpResponse, ValidateOtpRequest>({
      query: (body: ValidateOtpRequest) => ({
        url: "/Account/validateotp",
        method: "POST",
        body,
      }),
    }),
    getNewTokens: build.mutation<TokensResponse, TokensRequest>({
      query: (body: TokensRequest) => ({
        url: `/Account/refresh`,
        method: "POST",
        body,
      }),
    }),
    postDeviceAuthentication: build.mutation<DeviceAuthResponse, DeviceOtpRequest>({
      query: (body: DeviceOtpRequest) => ({
        url: `/Account/device-otp`,
        method: "POST",
        body,
      }),
    }),
    postValidateDeviceAuth: build.mutation<ValidateOtpResponse, ValidateDeviceAuthRequest>({
      query: (body: ValidateDeviceAuthRequest) => ({
        url: `/Account/validatePhoneOtp`,
        method: "POST",
        body,
      }),
    }),
    getUserAuthInfo: build.query<UserAuthDto, GetUserAuthInfoParams>({
      query: ({email, action}:GetUserAuthInfoParams) => ({
        url: `/Account/auth-info/${email}${action ? `?action=${encodeURIComponent(action)}` : ''}`,
        method: "GET",
      }),
    }),
    postEmailOtpValidation: build.mutation<boolean, ValidateDeviceAuthRequest>({
      query: (body: ValidateDeviceAuthRequest) => ({
        url: "/Account/validate-email-otp",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  usePostOtpValidationMutation,
  useGetNewTokensMutation,
  usePostDeviceAuthenticationMutation,
  usePostValidateDeviceAuthMutation,
  useLazyGetUserAuthInfoQuery,
  usePostEmailOtpValidationMutation
} = authenticationApi;
